module.exports = __webpack_public_path__ + "static/media/logo.211dc694.png";